export default __webpack_public_path__ + "static/dog-9157b81d4171f2d37c594bd24b97617c.png";